import { FaPhoneAlt } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import SectionLayout from 'src/layouts/SectionLayout';
import DividerIcon from '../CommonComps/Icons/DividerIcon';
import ContactUsForm from './ContactUsForm';

const ContactUsSection = () => {
  // rendering contact us section component here
  return (
    <SectionLayout id='contact' titleFirstPart='Get in' titleSecondPart='touch'>
      <div className='flex flex-col-reverse md:flex-row items-center justify-between mt-10 gap-10 bg-gradient-to-r from-legal-dark-gray via-legal-dark-blue to-legal-dark-gray rounded-3xl p-5 md:p-7 lg:p-10 text-legal-white'>
        <div>
          <div className='hidden md:block'>
            <h3 className='text-4xl lg:text-[45px] leading-[1] font-medium'>
              Got any questions?
            </h3>
            <h3 className='text-4xl lg:text-[45px] leading-[1] text-legal-brown font-bold italic mt-1'>
              Contact with us now!
            </h3>
          </div>

          <div>
            <div className='flex flex-col md:flex-row items-center text-center md:text-left gap-3 mt-5'>
              <div className='flex items-center justify-center text-legal-brown bg-legal-brown/40 size-[50px] rounded-full'>
                <FaLocationDot className='size-6' />
              </div>

              <div className='text-base lg:text-lg font-marcellus flex-1'>
                <p className='font-semibold text-legal-brown'>Address</p>
                <p>0665 Broadway st. 10234 BC, CANADA</p>
              </div>
            </div>

            <div className='flex flex-col md:flex-row items-center text-center md:text-left gap-3 mt-5'>
              <div className='flex items-center justify-center text-legal-brown bg-legal-brown/40 size-[50px] rounded-full'>
                <FaPhoneAlt className='size-6' />
              </div>

              <div className='text-base lg:text-lg font-marcellus'>
                <p className='font-semibold text-legal-brown'>Phone</p>
                <p>+1 123 567 8910</p>
              </div>
            </div>

            <div className='flex flex-col md:flex-row items-center text-center md:text-left gap-3 mt-5'>
              <div className='flex items-center justify-center text-legal-brown bg-legal-brown/40 size-[50px] rounded-full'>
                <MdEmail className='size-6' />
              </div>

              <div className='text-base lg:text-lg font-marcellus'>
                <p className='font-semibold text-legal-brown'>Email</p>
                <p>info@legalites.com</p>
              </div>
            </div>

            <div className='flex flex-col md:flex-row items-center text-center md:text-left gap-3 mt-5'>
              <div className='flex items-center justify-center text-legal-brown bg-legal-brown/40 size-[50px] rounded-full'>
                <MdEmail className='size-6' />
              </div>

              <div className='text-base lg:text-lg font-marcellus'>
                <p className='font-semibold text-legal-brown'>Email</p>
                <p>support@legalites.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className='hidden'>
          <DividerIcon height={'100%'} width={220} color='#D6BA88' />
        </div>

        <ContactUsForm />
      </div>
    </SectionLayout>
  );
};

export default ContactUsSection;
